import { Box, Container } from "@mui/material";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useAddEditSupplier } from "../hooks/useAddEditSupplier";
import AnimationFadeIn from "@components/AnimationFadeIn";
import SupplierFormCst from "../SupplierFormCst";
import { useState } from "react";
import useSWRMutation from "swr/mutation";
import { MethodType } from "src/services/type";
import { fetcher } from "src/services/config";

const EditSupplier: React.FC = () => {
  const { t } = useTranslation(["suppliers-page"]);
  const { idSupplier } = useParams();
  const [showModalWarning, setShowModalWarning] = useState(false);

  const navigate = useNavigate();

  const { columns, dataDetail, mutate } = useFetchDetail(
    ServicesURL.getSuppliers,
    idSupplier,
    PagesID["suppliers"],
  );

  const { columns: detailColumns } = useFetchDetail(
    ServicesURL.getSuppliers,
    undefined,
    PagesID["suppliers.details"],
  );

  // CUSTOM API FOR APPLICATION/JSON-PATCH+JSON
  const { trigger: triggerSupplier } = useSWRMutation(
    `${ServicesURL.postSuppliers}/${idSupplier}`,
    (url: string, arg: { arg: any }) =>
      fetcher<any>(`${url}`, MethodType.PUT, { ...arg.arg }),
  );

  const {
    onSubmit,
    openConfirmStatus,
    setOpenConfirmStatus,
    savedInputForm,
    savedDetails,
  } = useAddEditSupplier(triggerSupplier, mutate);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-suppliers.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <SupplierFormCst
              row={{
                ...(dataDetail && dataDetail.dto ? dataDetail.dto : {}),
                ...(dataDetail && dataDetail.dto && dataDetail.dto.details
                  ? dataDetail.dto.details
                  : {}),
              }}
              columns={columns}
              detailColumns={detailColumns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(-1);
              }}
            />
          </Box>
        )}
        <ModalConfirmsCst
          open={!!openConfirmStatus}
          title={t("outcome-item", { ns: "modal" })}
          description={t("outcome-item", { ns: "modal" })}
          onCallBackClosed={() => setOpenConfirmStatus(undefined)}
          status={openConfirmStatus}
        />
        <ModalConfirmsCst
          open={showModalWarning}
          title={t("duration-warning.title")}
          description={t("duration-warning.description")}
          routeToSamePage={true}
          onActionConfirmed={() => {
            setShowModalWarning(false);
            savedDetails && onSubmit(savedInputForm, savedDetails);
          }}
          onCallBackClosed={() => {
            setShowModalWarning(false);
          }}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default EditSupplier;
